export default {"src":"/_next/static/media/informatie.3368f163.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};